<div class="navHeader">
  <div *ngFor="let item of items">
    <p-button class="p-button-container" (click)="item.command()"><span class="itemLabel">{{item.label}}</span><i class="{{item.icon}}"></i></p-button>
  </div>
</div>
